import React, { useState } from 'react';
import { Upload, message } from 'antd';
import ImgCrop from 'antd-img-crop';
import PropTypes from 'prop-types';
import '../styles/AvatarUpload.css'

const AvatarUpload = ({ value, onChange, maxSize = 2 }) => {
  const [loading, setLoading] = useState(false);
  const [imageUrl, setImageUrl] = useState(value || '');

  // 上传前校验
  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('只能上传 JPG/PNG 格式的图片！');
      return false;
    }

    const isLtMaxSize = file.size / 1024 / 1024 < maxSize;
    if (!isLtMaxSize) {
      message.error(`图片必须小于 ${maxSize}MB！`);
      return false;
    }

    return true;
  };

  // 处理上传变化
  const handleChange = (info) => {
    if (info.file.status === 'uploading') {
      setLoading(true);
      return;
    }

    if (info.file.status === 'done') {
      setLoading(false);
      const url = info.file.response?.url || '';
      setImageUrl(url);
      onChange?.(url);
    }

    if (info.file.status === 'error') {
      setLoading(false);
      message.error('上传失败，请重试！');
    }
  };

  return (
    <ImgCrop rotate>
      <Upload
        name="avatar"
        listType="picture-circle"
        className="avatar-uploader"
        showUploadList={false}
        action="/api/upload"
        beforeUpload={beforeUpload}
        onChange={handleChange}
      >
        {imageUrl ? (
          <img 
            src={imageUrl} 
            alt="avatar" 
            style={{ 
              width: '100%', 
              height: '100%', 
              borderRadius: '50%',
              objectFit: 'cover' 
            }} 
          />
        ) : (
          <div>
            {loading ? '上传中...' : '+ 上传'}
          </div>
        )}
      </Upload>
    </ImgCrop>
  );
};

// 添加 PropTypes 验证
AvatarUpload.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  maxSize: PropTypes.number
};

export default AvatarUpload; 